// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: adNwSWS9Ft

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicMenuOption.module.css"; // plasmic-import: adNwSWS9Ft/css

import IconsOpenIcon from "./icons/PlasmicIcon__IconsOpen"; // plasmic-import: M4gp-x8W5R/icon

createPlasmicElementProxy;

export type PlasmicMenuOption__VariantMembers = {
  noPadding: "noPadding";
  sourceCategoryType: "twitter" | "youtube" | "spotify";
};
export type PlasmicMenuOption__VariantsArgs = {
  noPadding?: SingleBooleanChoiceArg<"noPadding">;
  sourceCategoryType?: SingleChoiceArg<"twitter" | "youtube" | "spotify">;
};
type VariantPropType = keyof PlasmicMenuOption__VariantsArgs;
export const PlasmicMenuOption__VariantProps = new Array<VariantPropType>(
  "noPadding",
  "sourceCategoryType"
);

export type PlasmicMenuOption__ArgsType = {
  title?: React.ReactNode;
  icon?: React.ReactNode;
};
type ArgPropType = keyof PlasmicMenuOption__ArgsType;
export const PlasmicMenuOption__ArgProps = new Array<ArgPropType>(
  "title",
  "icon"
);

export type PlasmicMenuOption__OverridesType = {
  menuOption?: p.Flex<"button">;
  freeBox?: p.Flex<"div">;
};

export interface DefaultMenuOptionProps {
  title?: React.ReactNode;
  icon?: React.ReactNode;
  noPadding?: SingleBooleanChoiceArg<"noPadding">;
  sourceCategoryType?: SingleChoiceArg<"twitter" | "youtube" | "spotify">;
  className?: string;
}

const $$ = {};

function PlasmicMenuOption__RenderFunc(props: {
  variants: PlasmicMenuOption__VariantsArgs;
  args: PlasmicMenuOption__ArgsType;
  overrides: PlasmicMenuOption__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "noPadding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.noPadding
      },
      {
        path: "sourceCategoryType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.sourceCategoryType
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <p.Stack
      as={"button"}
      data-plasmic-name={"menuOption"}
      data-plasmic-override={overrides.menuOption}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.menuOption,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.menuOptionnoPadding]: hasVariant(
            $state,
            "noPadding",
            "noPadding"
          ),
          [sty.menuOptionsourceCategoryType_spotify]: hasVariant(
            $state,
            "sourceCategoryType",
            "spotify"
          ),
          [sty.menuOptionsourceCategoryType_twitter]: hasVariant(
            $state,
            "sourceCategoryType",
            "twitter"
          ),
          [sty.menuOptionsourceCategoryType_youtube]: hasVariant(
            $state,
            "sourceCategoryType",
            "youtube"
          )
        }
      )}
      onClick={async event => {
        const $steps = {};
      }}
      ref={ref => {
        $refs["menuOption"] = ref;
      }}
    >
      {p.renderPlasmicSlot({
        defaultContents: (
          <div className={classNames(projectcss.all, sty.freeBox__a22PV)}>
            <IconsOpenIcon
              className={classNames(projectcss.all, sty.svg__xSyby)}
              role={"img"}
            />
          </div>
        ),
        value: args.icon,
        className: classNames(sty.slotTargetIcon)
      })}
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox, {
          [sty.freeBoxnoPadding]: hasVariant($state, "noPadding", "noPadding"),
          [sty.freeBoxsourceCategoryType_spotify]: hasVariant(
            $state,
            "sourceCategoryType",
            "spotify"
          )
        })}
      >
        {p.renderPlasmicSlot({
          defaultContents: "Show more",
          value: args.title,
          className: classNames(sty.slotTargetTitle, {
            [sty.slotTargetTitlesourceCategoryType_spotify]: hasVariant(
              $state,
              "sourceCategoryType",
              "spotify"
            ),
            [sty.slotTargetTitlesourceCategoryType_twitter]: hasVariant(
              $state,
              "sourceCategoryType",
              "twitter"
            ),
            [sty.slotTargetTitlesourceCategoryType_youtube]: hasVariant(
              $state,
              "sourceCategoryType",
              "youtube"
            )
          })
        })}
      </div>
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  menuOption: ["menuOption", "freeBox"],
  freeBox: ["freeBox"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  menuOption: "button";
  freeBox: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMenuOption__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMenuOption__VariantsArgs;
    args?: PlasmicMenuOption__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicMenuOption__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicMenuOption__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMenuOption__ArgProps,
          internalVariantPropNames: PlasmicMenuOption__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMenuOption__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "menuOption") {
    func.displayName = "PlasmicMenuOption";
  } else {
    func.displayName = `PlasmicMenuOption.${nodeName}`;
  }
  return func;
}

export const PlasmicMenuOption = Object.assign(
  // Top-level PlasmicMenuOption renders the root element
  makeNodeComponent("menuOption"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),

    // Metadata about props expected for PlasmicMenuOption
    internalVariantProps: PlasmicMenuOption__VariantProps,
    internalArgProps: PlasmicMenuOption__ArgProps
  }
);

export default PlasmicMenuOption;
/* prettier-ignore-end */
